import { IFaxFolder } from '@dataTypes/fax.type'
import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from '../errors/api-error'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_FAX')

const headers = {
  'Content-Type': 'application/json',
}

// Types
interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type GenericResponseData = Record<string, unknown>

type FaxFolderResponseData = { fax_folder?: IFaxFolder }
type FaxFolderListResponseData = { fax_folder?: IFaxFolder[] }

const getHeaders = (dbName?: string): Record<string, string> =>
  dbName ? { ...headers, 'x-db-name': dbName } : headers

export const getAllFaxFolder = async (
  dbName?: string,
): Promise<ApiResponse<FaxFolderListResponseData>> => {
  try {
    const response = await axios.get<ApiResponse<FaxFolderListResponseData>>(
      `${BUSINESS_LAYER_API}/api/v1/fax/folder/all`,
      { headers: getHeaders(dbName) },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in getAllFaxFolder:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const getFaxFolderById = async (
  id: string,
): Promise<ApiResponse<FaxFolderResponseData>> => {
  try {
    const response = await axios.get<ApiResponse<FaxFolderResponseData>>(
      `${BUSINESS_LAYER_API}/api/v1/fax/folder/${id}`,
      { headers },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in getFaxFolderById:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const createFaxFolder = async (
  data: IFaxFolder,
): Promise<ApiResponse<FaxFolderResponseData>> => {
  try {
    const response = await axios.post<ApiResponse<FaxFolderResponseData>>(
      `${BUSINESS_LAYER_API}/api/v1/fax/folder`,
      data,
      { headers },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in createFaxFolder:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const updateFaxFolderById = async (
  fax_folder_id: string,
  data: Partial<IFaxFolder>,
): Promise<ApiResponse<FaxFolderResponseData>> => {
  try {
    const response = await axios.put<ApiResponse<FaxFolderResponseData>>(
      `${BUSINESS_LAYER_API}/api/v1/fax/folder`,
      { fax_folder_id, data },
      { headers },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in updateFaxFolderById:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const deleteFaxFolderById = async (
  id: string,
): Promise<ApiResponse<GenericResponseData>> => {
  try {
    const response = await axios.delete<ApiResponse<GenericResponseData>>(
      `${BUSINESS_LAYER_API}/api/v1/fax/folder/${id}`,
      { headers },
    )
    return response.data
  } catch (e: unknown) {
    logger.error('Error in deleteFaxFolderById:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
